<div>
  <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
    <mat-icon>notes</mat-icon>
  </div>

  <div class="description">
    <strong>{{ isComplaint ? 'Complaint' : 'Note' }}</strong>
  </div>

  <!-- note -->
  <div class="d-flex mt-3 w-100">
    <user-avatar-component class="mr-2" [user]="{id: activity.lenderUserId, fullName: activity.meta.lenderUserName}"></user-avatar-component>

    <div class="w-100">
      <strong>{{ activity.meta.lenderUserName + ' ' }}</strong>
      <span class="activity-note-content">{{ activity.meta.content }}</span>
    </div>
  </div>
</div>
